module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.globals.currentUserInfo) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "panel panel-default text-left"
  }, [(
    _vm.globals.currentUserRole < 3 &&
    _vm.feature.isEnabled('changePasswordSelf') &&
    _vm.globals.isAccessAllowed('LoopOp_Password_ChangePasswordSelf') &&
    _vm.globals.isAccessAllowed('LoopOp_Password_ValidatePassword')
  ) ? _c('div', {
    attrs: {
      "id": "passwordResetContainer"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.lang.US0000))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showChangePasswordDialog = true
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.US0001) + "\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "filterSettingsContainer"
    }
  }, [_c('h2', [_vm._v("\n          " + _vm._s(_vm.lang.US0002) + "\n          "), _c('span', {
    staticClass: "beta-feature-indicator"
  }, [_vm._v("BETA")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox",
    attrs: {
      "id": "cbRememberFilterSettings"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rememberFilters),
      expression: "rememberFilters"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.rememberFilters) ? _vm._i(_vm.rememberFilters, null) > -1 : (_vm.rememberFilters)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.rememberFilters,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rememberFilters = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.rememberFilters = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rememberFilters = $$c
        }
      }, function($event) {
        (_vm.syncFilters = false), _vm.clearFilters()
      }]
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "text text-black"
  }, [_vm._v(_vm._s(_vm.lang.US0003))])])]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "cbRememberFilterSettings",
      "boundary": "viewport",
      "triggers": "hover",
      "placement": "topright",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.US0004))]), _vm._v(" "), _c('div', {
    staticClass: "checkbox",
    attrs: {
      "id": "cbSyncFilterSettings"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncFilters),
      expression: "syncFilters"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": !_vm.rememberFilters
    },
    domProps: {
      "checked": Array.isArray(_vm.syncFilters) ? _vm._i(_vm.syncFilters, null) > -1 : (_vm.syncFilters)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.syncFilters,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.syncFilters = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.syncFilters = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.syncFilters = $$c
        }
      }, function($event) {
        return _vm.clearSharedFilters()
      }]
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "text text-black"
  }, [_vm._v(_vm._s(_vm.lang.US0005))])])]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "cbSyncFilterSettings",
      "boundary": "viewport",
      "triggers": "hover",
      "placement": "topright",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.US0006))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.rememberFilters
    },
    on: {
      "click": _vm.clearFilters
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.US0007) + "\n        ")])], 1), _vm._v(" "), (
    (_vm.globals.currentUserRole === 1 ||
      _vm.globals.currentUserInfo.IsLoggedInAsUser) &&
    _vm.feature.isEnabled('loginAs')
  ) ? _c('div', {
    attrs: {
      "id": "loginAsContainer"
    }
  }, [_c('h2', [_vm._v("\n          " + _vm._s(_vm.lang.US0008) + "\n          "), _c('span', {
    staticClass: "beta-feature-indicator"
  }, [_vm._v("BETA")])]), _vm._v(" "), (_vm.globals.currentUserInfo.IsLoggedInAsUser) ? _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.leaveLoginAsSession()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.US0009) + "\n          ")])]) : _c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "width": '300px',
      "placeholder": _vm.lang.US0010,
      "allowClear": true
    },
    model: {
      value: (_vm.loginAsUserId),
      callback: function($$v) {
        _vm.loginAsUserId = $$v
      },
      expression: "loginAsUserId"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.userList), function(user) {
    return _c('option', {
      key: user.UserId,
      domProps: {
        "value": user.UserId
      }
    }, [_vm._v("\n              " + _vm._s(user.LastName) + ", " + _vm._s(user.FirstName) + " (" + _vm._s(user.LoginName) + ")\n            ")])
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.loginAsUserId
    },
    on: {
      "click": function($event) {
        return _vm.requestLoginAs()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.US0011) + "\n          ")])], 1)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('change-password-dialog', {
    attrs: {
      "showDialog": _vm.showChangePasswordDialog
    },
    on: {
      "dialogClosed": function($event) {
        _vm.showChangePasswordDialog = false
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae03ad60","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserSettings.vue
// module id = 1719
// module chunks = 1